
<b-table
	class="UsersTable"
	hoverable
	paginated
	backend-pagination
	:data="users"
	:loading="isLoading"
	:empty="!isLoading && total === 0"
	:total="total"
	:per-page="perPage"
	backend-sorting
	default-sort-direction="desc"
	:default-sort="[sortParams.field, sortParams.order]"
	@page-change="changePage"
	@sort="changeSortParams"
	:row-class="(row) => !row.isActive && 'is-not-active'"
>
	<template slot-scope="props">
		<b-table-column field="id" label="ID" sortable>
			{{ props.row.id }}
		</b-table-column>

		<b-table-column field="name" label="Użytkownik">
			<a href="" @click.prevent="$emit('user-click', props.row)" class="user-link">
				<span class="user-name">{{ props.row.username }}</span>
			</a>
		</b-table-column>

		<b-table-column field="orders" label="Liczba zamówień">
			{{ props.row.ordersCount || 0 }}
		</b-table-column>

		<b-table-column field="isActive" label="Konto aktywne">
			{{ props.row.isActive ? 'tak' : 'nie' }}
		</b-table-column>

		<b-table-column field="mailerIsEnabled" label="Mailer włączony">
			{{ props.row.mailerIsEnabled ? 'tak' : 'nie' }}
		</b-table-column>

		<b-table-column field="mailerIsActive" label="Mailer aktywowany">
			{{
				props.row.mailerIsActive
					? 'tak (' + (props.row.mailerMode === 'gmail' ? 'gmail' : 'zwykły') + ')'
					: 'nie'
			}}
		</b-table-column>

		<b-table-column field="isAdmin" label="Admin">
			{{ props.row.isAdmin ? 'tak' : 'nie' }}
		</b-table-column>

		<b-table-column field="createdDate" label="Dodano">
			<div v-if="props.row.createdDate">
				{{ props.row.createdDate | humanDate }}
				<small>{{ props.row.createdDate | date('DD/MM/YYYY') }}</small>
			</div>
			<span v-else>-</span>
		</b-table-column>
	</template>
	<template slot-scope="props" slot="header">
		{{ props.column.label }}
		<i
			v-show="sortParams.field === props.column.field"
			:class="{ mdi: true, 'is-desc': sortParams.order === 'desc' }"
		>
			arrow_upward
		</i>
	</template>
	<template slot="empty">
		<section class="section">
			<div class="content has-text-grey has-text-centered">
				<p>
					<b-icon icon="emoticon-sad" size="is-large"> </b-icon>
				</p>
				<p>Brak użytkowników.</p>
			</div>
		</section>
	</template>
	<template slot="bottom-left">
		<div class="per-page">
			<span>Wyświetlaj rekordów:</span>
			<b-select @input="changePerPage($event)" :value="perPage">
				<option
					v-for="(value, index) in perPageOptions"
					:key="index"
					:value="value"
					:selected="value === perPage"
				>
					{{ value }}
				</option>
			</b-select>
		</div>
	</template>
</b-table>
